import {
  BusinessRounded as BusinessRoundedIcon,
  DataUsageRounded as DataUsageRoundedIcon,
  DevicesRounded as DevicesRoundedIcon,
  LayersRounded as LayersRoundedIcon
} from '@mui/icons-material'
import { Avatar, Chip, Stack, Typography } from '@mui/material'
import { blue, green, orange, purple } from '@mui/material/colors'
import { t } from 'i18next'

import ZCard from '../../Shared/Components/ZCard'

const OrganizationProfileCard = ({ index, profile, onDelete, onEdit }) => {
  return (
    <ZCard
      key={`profile-card-${index}`}
      id={`profile-card-${profile.id}`}
      name="organizationProfile"
      actionDelete='organizations_profiles_d'
      actionUpdate='organizations_profiles_u'
      title={profile.name}
      titleInfo={
        <Chip
          label={profile.inUse ? t('organizationProfiles.inUse') : t('organizationProfiles.notInUse')}
          id={`profile-card-status-${profile.id}`}
          color={profile.inUse ? 'success' : 'default'}
          size="small"
          variant="outlined"
        />
      }
      subheader={null}
      content={
        <Stack
          direction="column"
          alignItems="left"
          spacing={2}
          padding={'16px'}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            spacing={3}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}>
              <Avatar sx={{ bgcolor: blue[50] }}>
                <DevicesRoundedIcon
                  fontSize="small"
                  color="primary"
                />
              </Avatar>
              <Typography variant="body2">
                <strong>{t('organizationProfiles.maxDevices')}:</strong> {profile.maxDevicesCount?.toLocaleString()}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}>
              <Avatar sx={{ bgcolor: green[50] }}>
                <LayersRoundedIcon
                  fontSize="small"
                  color="secondary"
                />
              </Avatar>
              <Typography variant="body2">
                <strong>{t('organizationProfiles.maxOrganizations')}:</strong> {profile.maxOrganizationsCount?.toLocaleString()}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            spacing={3}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}>
              <Avatar sx={{ bgcolor: orange[50] }}>
                <BusinessRoundedIcon
                  fontSize="small"
                  sx={{ color: orange[700] }}
                />
              </Avatar>
              <Typography variant="body2">
                <strong>{t('organizationProfiles.maxCalls')}:</strong> {profile.maxCallsPerMonthCount?.toLocaleString()}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}>
              <Avatar sx={{ bgcolor: purple[50] }}>
                <DataUsageRoundedIcon
                  fontSize="small"
                  sx={{ color: purple[700] }}
                />
              </Avatar>
              <Typography variant="body2">
                <strong>{t('organizationProfiles.dataRetention')}:</strong> {profile.dataRetentionPolicyInDays} {t('common.days', 'giorni')}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      }
      onDelete={() => onDelete(profile)}
      deleteAriaLabel={`${t('common.delete')} profilo organizzazione ${profile.name}`}
      onEdit={() => onEdit(profile)}
      editAriaLabel={`${t('common.edit')} profilo organizzazione ${profile.name}`}
      isDeleteVisible={!profile.inUse}
      variant="elevation"
    />
  )
}

export default OrganizationProfileCard
